import {
	CR_SET,
	CR_RESET_MESSAGE,
	CRS_FETCH_REQUEST,
	CRS_FETCH_FAILURE,
	CRS_FETCH_SUCCESS,
	CR_FETCH_REQUEST,
	CR_FETCH_FAILURE,
	CR_FETCH_SUCCESS,
	CR_CREATE_REQUEST,
	CR_CREATE_FAILURE,
	CR_CREATE_SUCCESS,
	CR_CLONE_REQUEST,
	CR_CLONE_FAILURE,
	CR_CLONE_SUCCESS,
	CR_UPDATE_REQUEST,
	CR_UPDATE_FAILURE,
	CR_UPDATE_SUCCESS,
	CR_SURVEY_SEND_REQUEST,
	CR_SURVEY_SEND_SUCCESS,
	CR_SURVEY_SEND_FAILURE,
} from '../constants/actionTypes';

const initialState = {
	isFetching: false,
	isUpdating: false,
	isCreating: false,
	isDeleting: false,
	isCloning: false,
	message: {
		type: '',
		text: '',
	},
	selected: false,
};

export default function reducer(state = initialState, action) {
	const { type, payload } = action;

	switch (type) {
		case CR_SET:
			return {
				...state,
				selected: Number(payload.id),
			};

		case CR_RESET_MESSAGE:
			return {
				...state,
				message: {
					type: '',
					text: '',
				},
			};

		case CR_CREATE_REQUEST:
			return {
				...state,
				isCreating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case CR_CREATE_FAILURE:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case CR_CREATE_SUCCESS:
			return {
				...state,
				isCreating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case CR_CLONE_REQUEST:
			return {
				...state,
				isCloning: true,
				message: {
					type: '',
					text: '',
				},
			};

		case CR_CLONE_FAILURE:
			return {
				...state,
				isCloning: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case CR_CLONE_SUCCESS:
			return {
				...state,
				isCloning: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case CRS_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
			};

		case CRS_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case CRS_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
			};

		case CR_FETCH_REQUEST:
			return {
				...state,
				isFetching: true,
				message: {
					type: '',
					text: '',
				},
				selected: false,
			};

		case CR_FETCH_FAILURE:
			return {
				...state,
				isFetching: false,
				message: {
					type: 'error',
					text: payload.message,
				},
				selected: false,
			};

		case CR_FETCH_SUCCESS:
			return {
				...state,
				isFetching: false,
				message: {
					type: '',
					text: '',
				},
				selected: Number(payload.id),
			};

		case CR_UPDATE_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};

		case CR_UPDATE_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		case CR_UPDATE_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case CR_SURVEY_SEND_REQUEST:
			return {
				...state,
				isUpdating: true,
				message: {
					type: '',
					text: '',
				},
			};
		case CR_SURVEY_SEND_SUCCESS:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'success',
					text: payload.message,
				},
			};

		case CR_SURVEY_SEND_FAILURE:
			return {
				...state,
				isUpdating: false,
				message: {
					type: 'error',
					text: payload.message,
				},
			};

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/CR.js